export const roundNumber = value => Math.round(value);
